import { getSession } from '@/utils/auth';

function getUserKey() {
    const session = getSession();
    return session?.user?.email || 'anon';
}

function storageKey(modalId) {
    return `dismiss:${modalId}:${getUserKey()}`;
}

export function isDismissedUntilEndOfDay(modalId) {
    const raw = localStorage.getItem(storageKey(modalId));
    if (!raw) return false;
    const until = Number(raw);
    if (!Number.isFinite(until)) {
        localStorage.removeItem(storageKey(modalId));
        return false;
    }
    if (Date.now() >= until) {
        localStorage.removeItem(storageKey(modalId));
        return false;
    }
    return true;
}

export function dismissUntilEndOfDay(modalId) {
    const end = new Date();
    end.setHours(24, 0, 0, 0);
    localStorage.setItem(storageKey(modalId), String(end.getTime()));
}

export function clearDismissal(modalId) {
    localStorage.removeItem(storageKey(modalId));
}
